export default function () {
    $(function () {
        const $modal = $('.sl-js-custom-modal');
        const $modalTitle = $('.sl-js-custom-modal-title', $modal);
        const $modalBtnLeft = $('.post-btn-id-0', $modal);
        const $modalBtnRight = $('.post-btn-id-1', $modal);
        const $spinner = $('.sl-js-modal-spinner', $modal);
        let isCustomModalClicked = false;
        $('button[sl-js-custom-modal]', 'form').on('click', function (e) {
            if (!isCustomModalClicked) {
                $spinner.hide();
                e.preventDefault();
                const $formBtn = $(this);
                $modal.addClass($formBtn.data('modal-class'));
                $modalTitle.html($(this).attr('sl-js-custom-modal'));
                $modalBtnLeft.html($formBtn.data('modal-text-0'));
                $modalBtnRight.html($formBtn.data('modal-text-1'));
                $modal.modal({
                    backdrop: 'static',
                    show: true
                });
                $('.sl-js-custom-modal .modal-footer a').on('click', function (e) {
                    e.preventDefault();
                    const selectedPostBtnID = $(this).data('post-btn-id');
                    const $formID = $formBtn.data('modal-post-btn-id-' + selectedPostBtnID);
                    // if it's a close button just dismiss the modal
                    if ($formID === $formBtn.data('modal-close-btn-id')) {
                        $modal.modal('hide');
                        return;
                    }
                    $spinner.show();
                    isCustomModalClicked = true;
                    //set the id of the submit button as the selected  post btn id where to redirect
                    $formBtn.attr('id', $formID).attr('name', $formID);
                    // submit the form by triggering the click
                    // (so that the button is submitted too)
                    $formBtn.trigger('click');
                });
            }
        });
    });
}